import { useRef } from 'react';
import useHandleOutside from '@/hooks/useHandleOutside';

const TamaraModal = ({ show, setShow, locale, amount, fromPDP }) => {
  const ref = useRef();
  useHandleOutside(ref, () => (!fromPDP ? setShow(false) : null));
  if (show)
    return (
      <div className='fixed top-0 left-0 z-[3000] flex h-screen max-h-screen w-screen items-center justify-center overflow-y-auto bg-black/60'>
        <div
          ref={ref}
          className='relative w-11/12 md:max-w-[594px] md:min-w-[594px]'
        >
          <iframe
            src={`https://cdn.tamara.co/widget-v2/tamara-widget.html?lang=${locale}&public_key=7739ae45-8dd4-4b8a-b863-8fc8f0956508&country=SA&amount=${amount}&inline_type=5`}
            width='100%'
            height='600px'
            title='Tamara Checkout'
            className='rounded-[32px]'
          />
        </div>
      </div>
    );
};

export default TamaraModal;
